/**
 * Browser-side API URL prefix for fetch requests.
 * In dev mode: empty string (requests go through Vite proxy as same-origin).
 * In production: the full API URL from env.
 */
export const API_URL = import.meta.env.DEV ? '' : import.meta.env.VITE_API_URL || '';

declare const __EXPRESS_SERVER_URL__: string;

/**
 * Actual Express server URL for contexts that need a real hostname
 * (e.g. Playground's miles_server_url, which runs in an iframe/service worker
 * and can't use the Vite proxy).
 */
export const SERVER_URL = import.meta.env.VITE_API_URL
  || (typeof __EXPRESS_SERVER_URL__ !== 'undefined' ? __EXPRESS_SERVER_URL__ : 'http://localhost:3100');

/**
 * Public, customer-facing download for the Miles plugin. Points at the stable
 * "latest" build on the self-hosted release channel (uploaded only on beta
 * releases; alpha releases skip it).
 *
 * The base path "releases.bymiles.ai/plugin" is a shared convention, not a
 * single source of truth: the release workflow writes the S3 object key
 * "plugin/miles-latest.zip" and hardcodes the same base for the update manifest
 * (.github/workflows/release-plugin.yml), and packages/miles-plugin/miles.php
 * defaults MILES_UPDATE_MANIFEST_URL to the same base. Keep them aligned.
 *
 * This is the build a user installs on their own WordPress site, distinct from
 * /api/v2/cloud/plugin.zip, which serves the build the cloud server is pinned
 * to for Playground installs.
 */
export const PLUGIN_DOWNLOAD_URL = 'https://releases.bymiles.ai/plugin/miles-latest.zip';
